module.exports = __webpack_public_path__ + "static/pic03-474a25eedc7306a7459c6f29e7307376.jpg";